import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { AffixRequestApi, EPlatform, ERequestState, KennelNameChangeRequestDto, RequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalKennelNameChangeRequestForm } from "./DrupalKennelNameChangeRequestForm";

export interface IDrupalKennelNameChangeRequestPageProps {}

export const DrupalKennelNameChangeRequestPage: React.FunctionComponent<IDrupalKennelNameChangeRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const kennelNameChangeRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(AffixRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<KennelNameChangeRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = kennelNameChangeRequestId) =>
          apiId > 0
            ? api.getKennelNameChangeRequest(apiId)
            : new KennelNameChangeRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: KennelNameChangeRequestDto) =>
          api.saveKennelImportRequest(KennelNameChangeRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.kennelNameChangeRequest}/${d.kennelNameChangeRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, kennelNameChangeRequestId]
    ),
    [kennelNameChangeRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.KennelNameChangeRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalKennelNameChangeRequestForm
                  kennelNameChangeRequestId={kennelNameChangeRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
